module.exports = __webpack_public_path__ + "static/media/9.256e2c34.jpg";